import AISectionCreator from './aiSectionCreator';

export default AISectionCreator;
